import { render, staticRenderFns } from "./RdsLoader.vue?vue&type=template&id=5bcf36d7&scoped=true&"
import script from "./RdsLoader.vue?vue&type=script&lang=js&"
export * from "./RdsLoader.vue?vue&type=script&lang=js&"
import style0 from "./RdsLoader.vue?vue&type=style&index=0&id=5bcf36d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcf36d7",
  null
  
)

export default component.exports